import { LocationValue } from '@confluence/comments-panel-utils/entry-points/commentsPanelHelper.ts';

export type AuthorWithAccountId = {
	displayName?: string | null;
	accountId?: string | null;
};

type ReplyToCommentParams = {
	parentCommentId: string;
	location: LocationValue;
	user?: AuthorWithAccountId;
};

/**
 * Creates the parameters object for setReplyToCommentId
 * @param parentCommentId - The ID of the parent comment to reply to
 * @param location - The location where the reply editor should appear (PANEL or FOOTER)
 * @param author - The author object with displayName and accountId
 * @param shouldIncludeUser - Whether to include the user object in the params
 * @returns The parameters object to pass to setReplyToCommentId
 */
export const createReplyToCommentParams = (
	parentCommentId: string,
	location: LocationValue,
	author: AuthorWithAccountId | null | undefined,
	shouldIncludeUser: boolean,
): ReplyToCommentParams => {
	return {
		parentCommentId,
		location,
		user:
			author && shouldIncludeUser
				? {
						displayName: author.displayName,
						accountId: author.accountId,
					}
				: undefined,
	};
};
